import { ImageUploadInput } from '../Form/ImageUploadInput/ImageUploadInput';
import { SubmitButton } from '../Form/SubmitButton/SubmitButton';
import { Form } from '../Form/Form';
import { Input } from '../Form/Input/Input';

import type { EditorResponse } from '../../types';

import styles from './EditorForm.module.scss';

type Props = {
  editor: EditorResponse;
  onSubmit: (values: EditorResponse) => Promise<void>;
};

function EditorForm({ editor, onSubmit }: Props) {
  const isNew = editor.id === undefined;

  return (
    <Form initialValues={editor} onSubmit={onSubmit}>
      <Input label="Name" name="name" />
      <ImageUploadInput label="Image" name="image" aspectRatio={1} />
      <div className={styles.buttons}>
        <SubmitButton>{isNew ? 'Create editor' : 'Save'}</SubmitButton>
      </div>
    </Form>
  );
}

export { EditorForm };
